import { useState, useEffect } from "react";
import './index.css';
// components
import { useHistory } from "react-router-dom";
import FormForgotPwd from "./FormForgotPwd";

const ForgotPassword = () => {
    const [forgotPwdSuccess, setForgotPwdSuccess] = useState(false);
    const history = useHistory();


     useEffect(() => {
            if (forgotPwdSuccess) {
                history.push("/login"); // Redirige al usuario al login
            }
          
        }, [forgotPwdSuccess, history]);

    return (
        <div className="login d-flex align-items-center justify-content-center" style={{
            background: "linear-gradient(to top, #dfe9f3 0%, white 100%)",
          }}>
           
            <div className="login-form shadow text-center">
                <img src="../img/logo-correos.png" className="mb-3" alt="boxit" height="93" width="220"/>
 
               { forgotPwdSuccess  ? null : (
                  <FormForgotPwd setForgotPwdSuccess={setForgotPwdSuccess} />
                )}
            </div>
        </div>
    );
}
 
export default ForgotPassword;